// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".phone-analysis-btn[data-v-0b8c3a0e]{line-height:36px;height:36px;padding:0 20px;margin-left:10px}", ""]);
// Exports
module.exports = exports;
